import StatusE from '../../types/statusE'
import { IncidentState } from './stateI'

const initialIncidentState: IncidentState = {
  status: StatusE.IDLE,
}

export default initialIncidentState
